const formatAreaDetails = (areaDetails) => {
    let provincesMap = new Map()
    let provinces = []
    for(let i=0;i<areaDetails.length;i++){
        let areaDetail = areaDetails[i]
        if(areaDetail.parentId===0){
            let province = {value:areaDetail.id,label:areaDetail.name,children:[]}
            provinces.push(province)
            provincesMap.set(province.value,province)
        }
    }
    let citysMap = new Map()
    for(let i=0;i<areaDetails.length;i++){
        let areaDetail = areaDetails[i]
        if(provincesMap.has(areaDetail.parentId)){
            let citys = provincesMap.get(areaDetail.parentId).children
            let city = {value:areaDetail.id,label:areaDetail.name,children:[]}
            citys.push(city)
            citysMap.set(city.value,city)
        }
    }
    for(let i=0;i<areaDetails.length;i++) {
        let areaDetail = areaDetails[i]
        if(citysMap.has(areaDetail.parentId)){
            let areas = citysMap.get(areaDetail.parentId).children
            let area = {value:areaDetail.id,label:areaDetail.name}
            areas.push(area)
        }
    }


    return provinces
}

const formatAgencyAreaDetails = (areas) => {
    const data = []

    //寻找根节点
    const top = areas.reduce((min, current) => {
        return current.id < min.id ? current : min;
    }, areas[0])
    const topArea = {value:top.id, label:top.name}
    data.push(topArea)

    const parentMap = new Map()
    let children = areas.filter(x=>x.parentId===top.id)
    if (children.length>0){
        topArea.children=[]
        children.forEach(child=>{
            const childArea = {value:child.id,label:child.name}
            topArea.children.push(childArea)
            parentMap.set(child.id, childArea)
        })
    }

    children = areas.filter(x=>parentMap.has(x.parentId))
    if (children.length>0){
        children.forEach(child=>{
            const parentArea = parentMap.get(child.parentId)
            if (!parentArea.children)parentArea.children=[]
            parentArea.children.push({value:child.id,label:child.name})
        })
    }

    return data
}

export {
    formatAreaDetails,
    formatAgencyAreaDetails
}